import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { useFormContext } from 'react-hook-form'

import { archiveFileReasons } from '../../util/categoryConsts'
import { FlexRow } from '../styles/Containers'
import FormSelect from '../inputFields/FormSelect'

function ArchiveFileForm({ loading }) {
  const { getValues } = useFormContext()
  const [defaultReason, setDefaultReason] = useState()

  useEffect(() => {
    setDefaultReason(getValues('reason') || '')
  }, [])

  return (
    <FlexRow width="100%">
      {defaultReason !== undefined && (
        <FormSelect basis="100%" id="reason" label="Reason" required options={archiveFileReasons} defaultValue={defaultReason} disabled={loading} />
      )}
    </FlexRow>
  )
}

ArchiveFileForm.propTypes = {
  loading: PropTypes.bool
}

export default ArchiveFileForm
